<script lang="ts">
  import clsx from 'clsx'
  import captionsState from '../../../stores/captions.svelte'
  import componentAttributesStore from '../../../stores/componentAttributes.svelte'
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import CaptionsIcon from '../icons/CaptionsIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
  import { THEMES } from '../../../const/themes'

  let hover = $state(false)
</script>

<ControlBarButton
  bind:hover
  onclick={() => videoStore.state.videoController?.toggleSubtitles()}
  hidden={!captionsState.state.subtitleTracks?.length ||
    videoStore.state.isChromecasting}
  tooltip={captionsState.state.subtitleEnabled
    ? translationsStore.state.hide_captions
    : translationsStore.state.show_captions}
>
  <CaptionsIcon />
  <div
    class={clsx(
      'absolute w-full h-[2px]',
      !captionsState.state.subtitleEnabled && 'hidden',
    )}
    style="background-color: {hover
      ? componentAttributesStore.state.buttonsHoverColor ||
        THEMES.DEFAULT.BUTTONS_HOVER_COLOR
      : componentAttributesStore.state.buttonsColor ||
        THEMES.DEFAULT.BUTTONS_COLOR};"
  ></div>
</ControlBarButton>
